export default `
fragment PublisherFragment on publishers {
  id
  name
  slug
  state
  editionsCount: editions_count
  userId: user_id
}
`;
